import React from "react";
// Components
import RowTools from "../../../../components/Table/RowTools";

const columns = ({  } = {}) =>
  [
    {
      // key: "Id",
      title: "#",
      dataIndex: "stt",
      width: "65px"
    },
    {
      // key: "",
      title: "Tên trạm",
      dataIndex: "tentram",
      render: value => <span className="row-name">{value}</span>
    }
  ].map(col => ({...col}));

export default columns;
